import { Add, Wallet } from '@mui/icons-material'
import { Box, Button, Skeleton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next';
import { useCreditsAndPlans } from './context';
import { useNavigate } from 'react-router-dom';

export default function CreditDetails() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { downMd, credits, creditsLoading } = useCreditsAndPlans()

    return (
        <Stack spacing={2}>
            <Box display="flex" alignItems='center' justifyContent='space-between'>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Wallet color="primary" sx={{ mr: 1 }} />
                    <Typography variant={downMd ? "h4" : "body1"} color="text.secondary">
                        {t("Total Credit")}
                    </Typography>
                </Box>
                {
                    creditsLoading ?
                        <Skeleton variant="text" width={100} height={20} />
                        :
                        <Typography variant={downMd ? "h4" : "body1"} fontWeight="bold">
                            {`${credits} ${t("currency.SAR")}`}
                        </Typography>
                }
            </Box>
            <Button
                id="popper-credit-details"
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={() => navigate("/merchant/balance")}
                startIcon={<Add color="white" />}
            >
                {t("Add Credits")}
            </Button>
        </Stack>
    )
}
